import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVolume2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.8916 4.10828C17.4539 5.67101 18.3315 7.79024 18.3315 9.99994C18.3315 12.2096 17.4539 14.3289 15.8916 15.8916M12.95 7.04994C13.7311 7.83131 14.1699 8.89093 14.1699 9.99578C14.1699 11.1006 13.7311 12.1602 12.95 12.9416M9.16663 4.16661L4.99996 7.49994H1.66663V12.4999H4.99996L9.16663 15.8333V4.16661Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgVolume2;
